/**
 * Filter Type Definitions
 * 
 * Extends filter types with optional dynamic properties for client-side and RPC filtering.
 */

/**
 * Extended GraphQL filter with optional dynamic properties
 */
export interface ExtendedGraphQLFilter extends Record<string, any> {
  _clientSideFilter?: unknown;
  _rpcFilter?: unknown;
}

/**
 * Query parameters for entity queries
 */
export interface QueryParams {
  first: number;
  after: string | null;
  filter: Record<string, any>;
  searchTerm?: string;
  _clientSideFilter?: unknown;
  _rpcFilter?: unknown;
}

/**
 * Type guard to check if a filter has extended properties
 */
export function isExtendedGraphQLFilter(filter: unknown): filter is ExtendedGraphQLFilter {
  return typeof filter === "object" && filter !== null;
}

/**
 * Safely extract client-side filter from extended filter
 */
export function extractClientSideFilter(filter: ExtendedGraphQLFilter): unknown {
  return filter._clientSideFilter;
}

/**
 * Safely extract RPC filter from extended filter
 */
export function extractRpcFilter(filter: ExtendedGraphQLFilter): unknown {
  return filter._rpcFilter;
}

/**
 * Remove extended properties from filter
 */
export function removeExtendedProperties(filter: ExtendedGraphQLFilter): void {
  delete filter._clientSideFilter;
  delete filter._rpcFilter;
}
